export const Options = {
    Salutation: [
        { text: "Herr", value: "m" },
        { text: "Frau", value: "w" },
        { text: "Divers", value: "d" },
    ],
    ResearchAssistant: [
        {text:"Bewerbung als wissenschaftlicher Mitarbeiter (m/w/d)",value:"Bewerbung als wissenschaftlicher Mitarbeiter (m/w/d)"}
    ],
    Trainee: [
        {text:"Bewerbung als Referendar (m/w/d)",value:"Bewerbung als Referendar (m/w/d)"}
    ]
}
